export default function (birthday) {
  // 判断数据类型是否是字符串
  if (typeof birthday !== 'string') {
    return {
      y: null
    }
  }
  // 判断 birthday 格式是否正确
  if (!/^\d{4}-\d{2}-\d{2}$/.test(birthday)) {
    return {
      y: null
    }
  }

  // 出生年月日
  var birthdayArr = birthday.split('-')
  var birthdayYear = Number(birthdayArr[0])
  var birthdayMonth = Number(birthdayArr[1])
  var birthdayDate = Number(birthdayArr[2])

  // 当前 UTC 时间
  var nowUTC = new Date()
  var nowYear = nowUTC.getFullYear()
  var nowMonth = nowUTC.getMonth() + 1
  var nowDate = nowUTC.getDate()

  // 计算年龄
  var y = nowYear - birthdayYear
  if (nowMonth < birthdayMonth || (nowMonth === birthdayMonth && nowDate < birthdayDate)) {
    y--
  }

  if (y < 0) {
    return {
      y: null
    }
  }

  var birthdayObj = new Date(birthdayYear + y, birthdayMonth - 1, birthdayDate)
  var nowObj = new Date(nowYear, nowMonth - 1, nowDate)
  var d = (nowObj - birthdayObj) / (1000 * 60 * 60 * 24)

  return {
    y: y,
    d: d
  }
}



// WEBPACK FOOTER //
// ./src/utils/getAgeFromBirthday.js